import _uniqueId from 'lodash/uniqueId';
import _delay from 'lodash/delay';

export function navbarParentClickableCompat($) {
  const hoverItems = $('[data-hover-group]');
  const mediumBreakpoint = '(min-width: 768px)';

  // add id if missing for whatever reason
  hoverItems.attr('id', function (i, value) {
    return value ? value : _uniqueId('c_hover_dropdown');
  });

  hoverItems.on('mouseover', function () {
    if (!window.matchMedia(mediumBreakpoint).matches) {
      return;
    }

    const parent = $(this).parent();
    parent.addClass('hover-active');

    // close dropdowns one level up, cancel all timers
    const uncles = parent.siblings();
    uncles.each((i, el) => {
      const hoverEl = $(el).children('[data-hover-group]');
      const dropdown = $(el).children('.dropdown-menu');

      // cancel timer
      const timerId = hoverEl.data('mouseoutTimer');
      if (timerId) {
        window.clearTimeout(timerId);
        hoverEl.data('mouseoutTimer', null);
      }

      dropdown.removeClass('show');
      $(el).removeClass('hover-active');
    });

    const timerId = $(this).data('mouseoutTimer');
    if (timerId) {
      window.clearTimeout(timerId)
    }

    $(this).siblings('.dropdown-menu').addClass('show');
  });

  hoverItems.on('mouseout', function () {
    const timerId = _delay(() => {
      $(this).siblings('.dropdown-menu').removeClass('show');
      $(this).parent().removeClass('hover-active');
    }, 600);

    $(this).data('mouseoutTimer', timerId);
  });

  hoverItems.siblings('.dropdown-menu').on('mouseover', function () {
    if (!window.matchMedia(mediumBreakpoint).matches) {
      return;
    }

    const hoverEls = $(this).siblings('[data-hover-group]');
    const timerId = hoverEls.data('mouseoutTimer');
    if (timerId) {
      window.clearTimeout(timerId);
      hoverEls.data('mouseoutTimer', null);
    }

    $(this).addClass('show');
  });
  hoverItems.siblings('.dropdown-menu').on('mouseout', function () {
    $(this).removeClass('show');
    $(this).parent().removeClass('hover-active');
  });
}



// WEBPACK FOOTER //
// ./assets/scripts/lib/bootstrap-navwalker.js